var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/ClassifierTree/nodes/DynamicGeneratedGroupContent/utils.tsx";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.some.js";
import React from 'react';
import { FolderDynamicGenerated, CubesBlue, CategoryBlue, FamilyBlue, FolderDynamicGeneratedChild, FolderGroupingChild, FolderGrouping, VirtualStandardSize, VirtualStandardSizeWithSum } from '@gmini/ui-kit';
import { getNode } from "../../../../classifier-service";
import { isGroupType } from "../../../../classifier-service/adapters";
import { findFlatChildren, findFlatParents } from "../../utils";
import { useDynamicGroupsConditions, useNodes, useTree } from "../../TreeContext";
import { jsx as _jsx } from "react/jsx-runtime";
var dynamicBlueColor = '#4C5ECF';
export function getIconByDynamicInfo(_ref) {
  var sourceType = _ref.sourceType,
      hasChildConditions = _ref.hasChildConditions,
      hasOwnConditions = _ref.hasOwnConditions,
      hasParentConditions = _ref.hasParentConditions,
      filter = _ref.filter;

  // Если прообраз - это существующая группа
  if (sourceType === 'UserClassifierGroup') {
    if (hasOwnConditions) {
      return /*#__PURE__*/_jsx(FolderGrouping, {
        color: dynamicBlueColor
      });
    }

    return hasChildConditions ? /*#__PURE__*/_jsx(FolderGroupingChild, {
      color: dynamicBlueColor,
      opacity: 1
    }) : /*#__PURE__*/_jsx(FolderDynamicGenerated, {});
  }

  if (sourceType === 'BimStandardSize') {
    if (filter !== null && filter !== void 0 && filter.includes('SimpleFieldCondition')) {
      return /*#__PURE__*/_jsx(VirtualStandardSizeWithSum, {});
    }

    return hasParentConditions ? /*#__PURE__*/_jsx(CubesBlue, {}) : /*#__PURE__*/_jsx(VirtualStandardSize, {});
  }

  if (sourceType === 'BimCategory') {
    return /*#__PURE__*/_jsx(CategoryBlue, {});
  }

  if (sourceType === 'BimFamily') {
    return /*#__PURE__*/_jsx(FamilyBlue, {});
  }

  if (sourceType === 'BimProperty') {
    return /*#__PURE__*/_jsx(FolderDynamicGeneratedChild, {
      color: dynamicBlueColor
    });
  }

  return /*#__PURE__*/_jsx(FolderDynamicGenerated, {});
} // TODO: useMemo hooks

export function useDynamicInfo(_ref2) {
  var _node$source2;

  var node = _ref2.node,
      path = _ref2.path;
  var parentClassifierId = node.parentClassifierId;
  var tree = useTree();
  var dynamicConditionsMap = useDynamicGroupsConditions();
  var nodes = useNodes();
  var dynamicConditions = React.useMemo(function () {
    return dynamicConditionsMap[parentClassifierId] || [];
  }, [dynamicConditionsMap, parentClassifierId]);
  var hasChildConditions = React.useCallback(function () {
    var allChildren = findFlatChildren(tree, path);
    return allChildren.some(function (child) {
      if (child.ref.type === 'DynamicGeneratedGroupNode') {
        var _childNode$source;

        var childNode = getNode(nodes, {
          type: 'DynamicGeneratedGroupNode',
          id: child.ref.id
        });
        return (childNode === null || childNode === void 0 ? void 0 : (_childNode$source = childNode.source) === null || _childNode$source === void 0 ? void 0 : _childNode$source.type) === 'UserClassifierGroup' && dynamicConditions.some(function (cond) {
          var _childNode$source2;

          return cond.sourceGroupId === ((_childNode$source2 = childNode.source) === null || _childNode$source2 === void 0 ? void 0 : _childNode$source2.id);
        });
      }
    });
  }, [dynamicConditions, nodes, path, tree]);
  var hasOwnConditions = React.useCallback(function () {
    return dynamicConditions.some(function (cond) {
      var _node$source;

      return cond.sourceGroupId === ((_node$source = node.source) === null || _node$source === void 0 ? void 0 : _node$source.id);
    });
  }, [dynamicConditions, (_node$source2 = node.source) === null || _node$source2 === void 0 ? void 0 : _node$source2.id]);
  var hasParentConditions = React.useCallback(function () {
    var parents = findFlatParents(tree, path);
    return parents.some(function (p) {
      return isGroupType(p.ref.type) && dynamicConditions.some(function (cond) {
        return cond.sourceGroupId === p.ref.id;
      });
    });
  }, [dynamicConditions, path, tree]);
  return React.useMemo(function () {
    return {
      hasChildConditions: hasChildConditions(),
      hasOwnConditions: hasOwnConditions(),
      hasParentConditions: hasParentConditions(),
      sourceType: node.source ? node.source.type : 'BimProperty',
      filter: node.filter
    };
  }, [hasChildConditions, hasOwnConditions, hasParentConditions, node.filter, node.source]);
}